import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@pella/sash-framework';
import ItemSummary from '../item-summary';
import styles from './index.module.scss';

const ItemGrouping = (props) => {
	const continueShopping = () => {
		//don't use gatsby navigate here, user will end up at dept page, not PLP
		location.assign(localStorage.getItem('plpurl') ?? '/shop/?options=transaction-type=buy-now');
	};

	return (
		<div className={styles.itemGroup}>
			<div className={styles.itemGroup_imageContainer}>
				<img
					className={styles.itemGroup_image}
					src={props.itemImage}
					alt={props.itemImageName}
				/>
			</div>
			<div className={styles.itemGroup_info}>
				{/* eslint-disable-next-line react/prop-types -- fix this */}
				<p className={styles.itemGroup_ProductName}>{props.fullName}</p>
				{props.itemPrice && props.hasCart && (
					<p className={styles.itemGroup_Price}>
						{props.itemPrice}
						{props.quantity > 1 ? ' (each)' : ''}
					</p>
				)}
				<p className={styles.itemGroup_Qty}>Quantity: {props.quantity}</p>
			</div>
			<div className={styles.itemGroup_actions}>
				{props.hasCart && (
					<Button
						color='primary'
						href='/shop/cart/'
						className={styles.itemGroup_Btn}
					>
						<Icon name='shopping_cart' />
						View Cart
					</Button>
				)}
				{props.projectID !== '' && props.modal === 'projects' && (
					<Button
						color='primary'
						href={'/account/project/details/?projectID=' + props.projectID}
						className={styles.itemGroup_Btn}
					>
						View Project
					</Button>
				)}
				<Button
					color='secondary'
					size='sm'
					onClick={continueShopping}
					className={styles.itemGroup_Btn}
				>
					Continue Shopping
				</Button>
			</div>
			<ItemSummary
				context={'modal'}
				defaultOpen={true}
				questionsAnswers={props.qanda}
				detailsHeading={props.detailsHeading}
				partNumber={props.partNumber}
			/>
		</div>
	);
};

ItemGrouping.propTypes = {
	modal: PropTypes.string,
	qanda: PropTypes.array,
	itemImage: PropTypes.string,
	itemImageName: PropTypes.string,
	itemPrice: PropTypes.string,
	quantity: PropTypes.number,
	hasCart: PropTypes.bool,
	detailsHeading: PropTypes.string,
	projectID: PropTypes.string,
	partNumber: PropTypes.string,
	cartReturn: PropTypes.bool,
};

export default ItemGrouping;
